function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { genComponentStyleHook } from "../../_util/genComponentStyleHook";
export var genTabsStyle = function genTabsStyle(token) {
  var antCls = token.antCls,
    componentCls = token.componentCls,
    colorInfo = token.colorInfo,
    colorInfoBg = token.colorInfoBg,
    colorTextSecondary = token.colorTextSecondary;
  return _defineProperty({}, componentCls, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "&".concat(componentCls, "-top, &").concat(componentCls, "-bottom"), _defineProperty({}, "".concat(componentCls, "-nav::before"), {
    // 页签位置为 top 和 bottom 时，去掉分割线
    border: 'none'
  })), "".concat(componentCls, "-tab"), _defineProperty({}, "".concat(componentCls, "-tab-tag"), {
    color: colorTextSecondary,
    fontFamily: 'PingFangSC',
    fontSize: 12,
    borderRadius: 12,
    marginInlineEnd: 0,
    height: 20
  })), "".concat(componentCls, "-tab-active"), _defineProperty({}, "".concat(componentCls, "-tab-tag"), {
    color: colorInfo,
    backgroundColor: colorInfoBg
  })), "".concat(componentCls, "-tab[data-node-key^=divider-]"), _defineProperty({
    cursor: 'default'
  }, "".concat(componentCls, "-tab-btn"), _defineProperty({
    // make horizontal divider width 100% work
    width: '100%'
  }, "".concat(componentCls, "-divider"), _defineProperty(_defineProperty({
    margin: 0
  }, "&".concat(antCls, "-divider-vertical"), {
    height: token.sizeMD
  }), "&".concat(antCls, "-divider-horizontal"), {
    width: '100%'
  })))), "".concat(componentCls, "-ink-bar"), {
    // inkbar 带圆角
    borderRadius: '1px'
  }));
};
export default (function (prefixCls) {
  var useStyle = genComponentStyleHook('Tabs', function (token) {
    return [genTabsStyle(token)];
  });
  return useStyle(prefixCls);
});